// extracted by mini-css-extract-plugin
module.exports = {"details":"NFTHistorySection_details__hQPRt","descBorder":"NFTHistorySection_descBorder__jb6Xo","noCategory":"NFTHistorySection_noCategory__npCyJ"};